import React from "react";
import { APP_DOMAIN } from "../../constants/constants";
export const SpellCheckerButton = ({ spellCheckerToggleHander, suggestionLoader, spellChecker }) =>{
    return (
        <span className="menubar__button custom-summary" >                       
            <div className="on-off-btn light-green spell-cheker">
                {(suggestionLoader && spellChecker) ? 'Checking...' : <label htmlFor="spellChecker" onClick={spellCheckerToggleHander}><img src={`${APP_DOMAIN}/assets/images/${spellChecker ? 'spell-check-green.svg' : 'spell-check-gray.svg'}`} width="20px" /></label>} 
            </div>
        </span>
    );
}